import { Component, EventEmitter, Input, Output, SimpleChange } from '@angular/core';
import { Router } from '@angular/router';
import { ProjectService } from 'src/app/Services/project.service';
import { MatDialog } from '@angular/material/dialog';
import { DemoReportModalComponent } from '../demo-report-modal/demo-report-modal.component';
import moment from "moment";
import { hasCompanyRole } from 'src/app/utils/role.utils';
import { computeDaysUntilExpiry } from 'src/app/utils/billing-display.util';

@Component({
    selector: 'quota-banner',
    // standalone: true,
    // imports: [],
    templateUrl: './quota-banner.component.html',
    styleUrl: './quota-banner.component.css',
    standalone: false
})
export class QuotaBannerComponent {

  @Input() DeleteEmployee: false;
  @Input() closeButton: false;
  @Input() isProfile: false;
  @Input() isShowButton: any = true;
  @Input() hideTrialBanner: boolean = false;
  @Input() hideExpiredBanner: boolean = false;
  @Input() hideFeatureBanner: boolean = false;  // Use this to hide feature banner on specific pages (e.g., billing)
  
  isAdmin = true;
  isQuota = false;
  isTrialBanner = true;
  isExpiredBanner = true;
  quotaStatus = '';
  daysRemaining: number;
  isExpiryPast = false;
  allUserList;
  totalUser;
  availableUser;
  dateOfExpiration: string = '';
  isFeatureBannerVisible: boolean = false;  // Calculated internally based on conditions

  constructor(private _projectService: ProjectService, private router: Router, private dialog: MatDialog) {
    if (sessionStorage.getItem('isTrialBanner')) {
      this.isTrialBanner = true;
      this.isExpiredBanner = true;
    }
    this.getUSer();
    this._projectService.EmployeeList.subscribe((value) => {
      this.getUSer();
    });
    this._projectService.dashboardTourActive.subscribe((value: any) => {
      this.getUSer();
    });
    this.isBannerDisplay();
  }


  ngOnChanges(changes: SimpleChange) {
    this.getUSer();
  }

  getUSer() {
    let roleArr = [];
    this._projectService.getUser().subscribe((data: any) => {
      roleArr = data.role;
      let quotaStatus = data.meta.quota_status;
      this.quotaStatus = quotaStatus;
      this.dateOfExpiration = moment(data.meta.expires_at).format('DD/MM/YYYY');
      const subscriptionStatus = (data.meta.subscription_status || '').toLowerCase();

      if (quotaStatus == 'active' || quotaStatus == 'Active') {
        if (this.expiringDate(data.meta.expires_at, data.meta.today_date) <= data.meta.adv_pay) {
          this.isTrialBanner = false;
          this.isExpiredBanner = true;
        }
      }
      if (quotaStatus == 'trial' || quotaStatus == 'Trial') {
        this.isTrialBanner = false;
        this.isExpiredBanner = true;
      }
      if (quotaStatus == 'trial-expired' || quotaStatus == 'Trial-expired' || quotaStatus == 'expired' || quotaStatus == 'Expired') {
        this.isTrialBanner = true;
        this.isExpiredBanner = false;
        if (quotaStatus == 'expired' || quotaStatus == 'Expired') {
          this.isQuota = true;
        }
      }
      if (subscriptionStatus === 'active') {
        this.isTrialBanner = true;
        this.isExpiredBanner = true;
      }
      if (sessionStorage.getItem('isTrialBanner') && !this.closeButton) {
        this.isTrialBanner = true;
        this.isExpiredBanner = true;
      }

      this.totalUser = data.meta.quota_allowed;
      this.availableUser = data.meta.quota_remaining == 'false' || data.meta.quota_remaining == false ? 0 : data.meta.quota_remaining;
      this.availableUser = this.availableUser < 0 ? 0 : this.availableUser;
      if (data.meta.expires_at) {
        this.updateDaysRemaining(data.meta.expires_at, data.meta.today_date);
        if (
          (quotaStatus === 'active' || quotaStatus === 'Active') &&
          this.isExpiryPast
        ) {
          this.isTrialBanner = false;
          this.isExpiredBanner = true;
        }
      }

      this.isAdmin = hasCompanyRole(data);

      // Calculate feature banner visibility
      this.calculateFeatureBannerVisibility(data);
    })
  }

  /**
   * Calculate feature banner visibility based on conditions:
   * - Trial: Show only if employee created AND report_recipient_emails is empty
   * - Paid/Active: Show only if report_recipient_emails is empty
   * - Don't show for expired accounts or if hideFeatureBanner input is true
   */
  calculateFeatureBannerVisibility(data: any) {
    // If hideFeatureBanner input is true, don't show
    if (this.hideFeatureBanner) {
      console.log('[FeatureBanner] hideFeatureBanner is true, hiding');
      this.isFeatureBannerVisible = false;
      return;
    }

    // If banner was manually closed in this session, don't show
    if (sessionStorage.getItem('isFeatureBannerClosed')) {
      console.log('[FeatureBanner] Banner was closed by user, hiding');
      this.isFeatureBannerVisible = false;
      return;
    }

    // Get report_recipient_emails and check if empty
    const reportRecipientEmails = data.meta?.report_recipient_emails || '';
    const isReportEmailsEmpty = !reportRecipientEmails || String(reportRecipientEmails).trim() === '';

    // Calculate employees created
    const quotaAllowed = Number(data.meta?.quota_allowed) || 0;
    const quotaRemaining = data.meta?.quota_remaining == 'false' || data.meta?.quota_remaining == false 
      ? 0 
      : Number(data.meta?.quota_remaining) || 0;
    const employeesCreated = quotaAllowed - quotaRemaining;
    const hasCreatedEmployee = employeesCreated > 0;

    // Get quota status
    const status = (data.meta?.quota_status || '').toString().toLowerCase().trim();
    const isExpired = status.includes('expired');
    const isTrial = status === 'trial';
    const isActive = status === 'active';

    // Determine visibility
    if (isExpired) {
      this.isFeatureBannerVisible = false;
    } else if (isTrial) {
      // Trial: Show only if employee created AND report_recipient_emails is empty
      this.isFeatureBannerVisible = hasCreatedEmployee && isReportEmailsEmpty;
    } else if (isActive) {
      // Paid/Active: Show only if report_recipient_emails is empty
      this.isFeatureBannerVisible = isReportEmailsEmpty;
    } else {
      // Default: show if emails empty (handles any unexpected status)
      this.isFeatureBannerVisible = isReportEmailsEmpty;
    }
  }

  expiringDate(strExpiredDate, strTodayDate) {
    const expirationDate = new Date(strExpiredDate);
    const timeDifference = expirationDate.getTime() - new Date(strTodayDate).getTime();
    const daysDifference = timeDifference / (1000 * 60 * 60 * 24);

    return daysDifference + 1;
  }

  updateDaysRemaining(strDate: string, strToday?: string) {
    const days = computeDaysUntilExpiry(strDate, strToday);
    this.daysRemaining = days ?? 0;
    this.isExpiryPast = days !== null && days < 0;
  }

  IncreaseLimitAction() {
    window.open('Https://supersee.io', '_blank')
  }
  trialCloseBanner() {
    sessionStorage.setItem('isTrialBanner', 'false');
    this.isTrialBanner = true;
    this.isExpiredBanner = true;
    this.isBannerDisplay()
  }

  isBannerDisplay() {
    if (sessionStorage.getItem('isTrialBanner') && this.closeButton) {
      this.getUSer();
    }
  }

  renewPlanAction() {
    this.router.navigate(["/billings"]);
  }

  goToSettings() {
    this.router.navigate(["/employee/setting"]);
  }

  closeFeatureBanner() {
    this.isFeatureBannerVisible = false;
    sessionStorage.setItem('isFeatureBannerClosed', 'true');
  }

  viewDemoReport() {
    // Open demo report in a modal
    this.dialog.open(DemoReportModalComponent, {
      panelClass: 'demo-report-dialog',
      width: '900px',
      maxWidth: '95vw',
      height: '90vh',
      maxHeight: '95vh',
      disableClose: false,
    });
  }
}
